export default "__VITE_ASSET__Dl5uy5wF__"